import React from "react";
import Layout from "@app/Layout";
import Canonical from "@shared/head/Canonical";
import { TildaContent } from "@shared/TildaContent";
import { TILDA_CSS_FILES } from "@shared/tildaCss";
import "@styles/tilda.scss";

export const Head = () => (
  <>
    <title>Artificial Intelligence</title>
    <meta name="description" content="A study of how to produce machines with some of the qualities that..." />
    <meta property="og:image" content="" />
    <Canonical url="https://www.dashly.io/custom-chatbot/glossary/artificial-intelligence/" />
    {TILDA_CSS_FILES.map((href) => (
      <link rel="stylesheet" href={href} key={href} />
    ))}
  </>
);

export default function GlossaryArtificialIntelligence({ location }: { location: Location }) {
  return (
    <Layout location={location} className="page page-tilda">
      <TildaContent html={`<!--allrecords--><div id="allrecords" class="t-records" data-hook="blocks-collection-content-node" data-tilda-project-id="867315" data-tilda-page-id="15967764" data-tilda-page-alias="custom-chatbot/glossary/artificial-intelligence/" data-tilda-formskey="f5a18e42992040ed73e3d8542e0e8cee" data-tilda-root-zone="com" data-tilda-project-headcode="yes" ><div id="rec263432439" class="r t-rec t-rec_pt_120 t-rec_pb_45" style="padding-top:120px;padding-bottom:45px;background-color:#f8f8ff; " data-animationappear="off" data-record-type="758" data-bg-color="#f8f8ff"><!-- t758 --><div class="t758"><div class="t-container"><div class="t758__col t-col t-col_7 "><div class="t758__wrapper t-align_left"><ul class="t758__list"><li class="t758__list_item"><div class="t758__link-item__wrapper" ><a class="t-menu__link-item " href="/custom-chatbot/">Leadbot</a></div><span class="t758__breadcrumb-divider">»</span> </li><li class="t758__list_item"><div class="t758__link-item__wrapper" ><a class="t-menu__link-item " href="/custom-chatbot/glossary/">Chatbot Glossary</a></div><span class="t758__breadcrumb-divider">»</span> </li><li class="t758__list_item"><div class="t758__link-item__wrapper" ><a class="t-menu__link-item t758__link-item_active" href="/custom-chatbot/glossary/artificial-intelligence/">Artificial Intelligence</a></div></li></ul></div></div></div></div><style>#rec263432439 .t758__breadcrumb-divider {
color:#141414;
}
#rec263432439 .t758 .t-menu__link-item{ 
-webkit-transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out;
transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out; 
}
#rec263432439 .t758 .t-menu__link-item:hover {
color: #9e9e9e !important; }
#rec263432439 .t758 .t-menu__link-item:focus-visible{
color: #9e9e9e !important; }</style><style> #rec263432439 .t758__link-item__wrapper .t-menu__link-item { font-weight: 300; }</style><style> #rec263432439 .t758__breadcrumb-divider { font-weight: 300; }</style></div><div id="rec261014431" class="r t-rec t-rec_pt_30 t-rec_pb_30" style="padding-top:30px;padding-bottom:30px;background-color:#f8f8ff; " data-record-type="30" data-bg-color="#f8f8ff"><!-- T015 --><div class="t015"><div class="t-container t-align_center"><div class="t-col t-col_10 t-prefix_1"><h1 class="t015__title t-title t-title_lg" field="title"><div style="font-size:42px;line-height:52px;text-align:center;font-family:'Stag';" data-customstyle="yes"><span style="font-weight: 500;">What is Artificial Intelligence?</span></div></h1> </div></div></div><style> #rec261014431 .t015__uptitle { text-transform: uppercase; }</style></div><div id="rec263548339" class="r t-rec t-rec_pt_30 t-rec_pb_45" style="padding-top:30px;padding-bottom:45px;background-color:#f8f8ff; " data-record-type="127" data-bg-color="#f8f8ff"><!-- T119 --><div class="t119"><div class="t-container "><div class="t-col t-col_8 t-prefix_2"><div class="t119__preface t-descr" field="text"><div style="font-size:18px;line-height:32px;text-align:center;font-family:'Montserrat';" data-customstyle="yes"><strong>Artificial intelligence </strong>(AI) is the study of how to produce machines that have some of the qualities that the human mind has, such as the ability to understand language, recognize pictures, solve problems, and learn. <br />(<a href="https://dictionary.cambridge.org/dictionary/english/" target="_blank" style="color:rgb(251, 100, 4) !important;">Cambridge Advanced Learner's Dictionary &amp; Thesaurus</a>)</div></div></div></div></div><style> #rec263548339 .t119__preface { opacity: 0.7; }</style></div><div id="rec265052815" class="r t-rec" style=" " data-animationappear="off" data-record-type="121" ><!-- T123 --><div class="t123" ><div class="t-container_100 "><div class="t-width t-width_100 ">

			<section class="hero__nav">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<ul class="nav align-items-center">
					<li class="nav-item mr-3">
						Chatbot:
					</li>
					<li class="nav-item">
						<a class="nav-link" href="/custom-chatbot/">Overview</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="/custom-chatbot/leadbot-features/">Features</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="/custom-chatbot/pricing/">Pricing</a>
					</li>
					<li class="nav-item">
						<a class="nav-link active" href="/custom-chatbot/glossary/">Glossary</a>
					</li>
					<li class="nav-item ml-auto hero__nav__registration mr-3">
						<a class="nav-link" href="/panel/register">START FOR FREE</a>
					</li>
					<li class="nav-item hero__nav__login">
						<a class="nav-link" href="/panel/login">Sign in</a>
					</li>
				  </ul>
			</div>
		</div>
	</div>
</section>

<style>
	.row {
		display: flex;
	}
	.hero__nav {
		background-color: #f8f8ff;
		border-top: 1px solid #eee;
		position: sticky;
		top: 0;
		z-index: 10;
		font-family: 'Open Sans',Arial,sans-serif;
	}
	.hero__nav .nav {
		display: flex;
		margin-top: 0 !important;
		padding-top: 16px;
		padding-bottom: 16px;
		list-style-type: none;
		margin-bottom: 0 !important;
	}
	.hero__nav li {
		padding-left: 0 !important;
		margin-bottom: 0 !important;
	}
	.hero__nav .nav-link {
		display: inline-block;
		margin-left: 12px;
		padding: 8px 12px;
		border-radius: 5px;
		border: 1px solid #f8f8ff;
	}
	.hero__nav .nav-link.active {
		background-color: transparent;
		border: 1px solid #f60
	}
	.hero__nav .nav-link:hover:not(.active) {
		background-color: #FFF;
		
	}
	.hero__nav__registration , .hero__nav__login , .hero__nav li::before , .hero__nav li::marker {
		display: none;
	}
	.hero__nav__registration .nav-link {
		background-color: #f60;
		color: #fff !important;
		padding: 8px 24px;
	}
	.hero__nav__login .nav-link {
		color: #000;
	}
	.hero__nav__registration .nav-link:hover {
		background-color: #ffab47 !important;
	}
	.container {
		margin: 0 auto;
		max-width: 1200px !important;
	}
	.align-items-center {
    	-webkit-box-align: center!important;
		-webkit-align-items: center!important;
		-moz-box-align: center!important;
		-ms-flex-align: center!important;
		align-items: center!important;
	}
	.mr-3, .mx-3 {
		margin-right: 1rem!important;
	}
</style>
			 
			
</div> </div></div></div><div id="rec261011286" class="r t-rec t-rec_pt_30 t-rec_pb_30" style="padding-top:30px;padding-bottom:30px; " data-record-type="127" ><!-- T119 --><div class="t119"><div class="t-container "><div class="t-col t-col_8 t-prefix_2"><div class="t119__preface t-descr" field="text"><div style="font-size:16px;line-height:26px;font-family:'Montserrat';" data-customstyle="yes">I<span style="color: rgba(0, 0, 0, 0.97);">n simple words, these machines can learn and simulate human intelligence: think like humans and mimic their actions to achieve a specific goal. For this, AI has three cognitive skills:<br /><br /></span><ul><li><span style="color: rgba(0, 0, 0, 0.97);"><strong>Reasoning</strong>. The ability to choose the right algorithm to reach the desired result. <br /> </span></li> <li> <span style="color: rgba(0, 0, 0, 0.97);"><strong>Self-correction</strong>. Automatically fix the algorithms to provide the most accurate results.</span></li><li><span style="color: rgba(0, 0, 0, 0.97);"><strong>Learning</strong>. Collecting and processing data for further usage and decisions making.</span></li></ul><span style="color: rgba(0, 0, 0, 0.97);"><br />Thanks to "The Terminator" and "I, Robot" movies, there are concerns about the consequences of AI learning and decision-making abilities. <br /><br />But don't worry, AI-powered apps we use today are safe… at least for now ???? <br /><br /> For example, there are three brilliant AI solutions that we are using today, marketing machine learning as a present thing – not the future. <br /><br /> </span><ul> <li> <span style="color: rgba(0, 0, 0, 0.97);"><strong>Siri</strong> is the Apple personal assistant on iPhone and iPad. This voice-activated assistant helps find information, get directions, send messages, make voice calls, open applications, and add events to the calendar. <br /> </span></li> <li> <span style="color: rgba(0, 0, 0, 0.97);"><strong>Tesla</strong>. In addition to many accolades it has achieved, tesla also has features like self-driving, predictive capabilities, and absolute technological innovation.<br /> </span></li> </ul><ul><li> <span style="color: rgba(0, 0, 0, 0.97);"><strong>Netflix</strong>'s service uses predictive technology to offer recommendations based on consumers' reactions, interests, choices, and behavior. The technology examines many records to recommend movies based on your previous liking and responses. </span><br /><br /> </li></ul><br /> <strong><span data-redactor-tag="span" style="color: rgb(255, 156, 0);"><a href="https://www.dashly.io/custom-chatbot/glossary/" style="color:#fb6404 !important;">Back to Glossary</a> <strong><span data-redactor-tag="span"><strong><span data-redactor-tag="span"><a href="https://www.dashly.io/custom-chatbot/glossary/" style="outline: 0px;">➡</a></span></strong></span></strong><strong></strong></span></strong><ul> </ul></div></div></div></div></div><style> #rec261011286 .t119__preface { opacity: 0.7; }</style></div><div id="rec358555044" class="r t-rec" style=" " data-animationappear="off" data-record-type="131" ><!-- T123 --><div class="t123" ><div class="t-container_100 "><div class="t-width t-width_100 ">

			<script type="application/ld+json">
  {
    "@context": "http://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Dashly",
        "item": "https://www.dashly.io"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Dashly's Leadbot",
        "item": "https://www.dashly.io/custom-chatbot/"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Chatbot Glossary",
        "item": "https://www.dashly.io/custom-chatbot/glossary/"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Artificial Intelligence",
        "item": "https://www.dashly.io/custom-chatbot/glossary/artificial-intelligence/"
      }
    ]
  }
</script>
			 
			
</div> </div></div></div></div><!--/allrecords-->`} />
    </Layout>
  );
}
